import { render, staticRenderFns } from "./ProjectBidComponent.vue?vue&type=template&id=27955f4c&scoped=true"
import script from "./ProjectBidComponent.vue?vue&type=script&lang=js"
export * from "./ProjectBidComponent.vue?vue&type=script&lang=js"
import style0 from "./ProjectBidComponent.vue?vue&type=style&index=0&id=27955f4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27955f4c",
  null
  
)

export default component.exports